export enum UserTypeEnum {
    Admin = 1,
    Agent = 2,
    Client = 3
}
